// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"501":"b29ee59aad716d0a4bef","832":"3f2900d90225113664e5","856":"3db73b2f79cb4f04e5ca","940":"bde8affb006a4a1b2bf1"}[chunkId] + ".js";
};